import styled from 'styled-components';

export const Label = styled.label`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.common.white};
  height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  cursor: pointer;
  transition: 0.4s ease-in-out all;

  &:hover {
    box-shadow:
      0px 12px 27px 0px #0000000d,
      0px 49px 49px 0px #0000000a,
      0px 111px 66px 0px #00000008,
      0px 197px 79px 0px #00000003,
      0px 307px 86px 0px #00000000;
  }

  h4 {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: center;

    color: #000;
    margin-top: 31px;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: center;
    margin: 16px 0 0 0 !important;
    padding: 0;
    color: #5e5e5e;
  }

  input {
    display: none;
  }
`;
